var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-testing-step-7"},[_c('button',{staticClass:"v-testing-step__button stop-demo",on:{"click":function($event){return _vm.$emit('stop-demo')}}},[_vm._v("\r\n    Завершить демо-тур и удалить тестовые данные\r\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }